import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { sxs } from './_sxs'
import { HelpCenterCardButtonProps } from './_props'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'

const HelpCenterCardButtonClickable = ({
    buttonName,
    handleClick,
    colorVariant = 'primary',
}: HelpCenterCardButtonProps) => (
    <Box sx={sxs.cardAction}>
        <Button
            endIcon={<ArrowOutwardIcon sx={sxs.buttonIcon} />}
            sx={[sxs.button, colorVariant === 'secondary' ? sxs.buttonSecondary : null]}
            onClick={handleClick}
        >
            {buttonName}
        </Button>
    </Box>
)

export default HelpCenterCardButtonClickable
